import React from 'react';
import { BrowserRouter as Router, Route, Routes,  Navigate } from 'react-router-dom'
// Pages 
import Home from './pages/index';
import Products from './pages/products';
import Contact from './pages/contact';


function Routers () {
    return (
       <Router>
           <Routes>
              <Route path="/" exact element={<Home/>}/>
              <Route path="/products" exact element={<Products/>}/>
              <Route path="/contact" exact element={<Contact/>}/>
          </Routes>
        </Router>
      )
}
export default Routers; 